import { compose, hoistStatics, withHandlers, lifecycle, withProps, defaultProps } from 'recompose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Language from './Language';
import fh from '../../../helpers/form.helper';
import ModelService from '../../../services/language.service';
import CardLoading from '../../../components/CardLoading';
import WithLoading from '../../../components/WithLoading';
import { uploadSelectors, uploadActions } from '../../../reducers/upload';
import { settingsActions } from '../../../reducers/settings';

const imageSelector = uploadSelectors.getTempFile('image');

const mapStateToProps = state => ({
  image: imageSelector(state),
});

const mapDispatchToProps = {
  removeTempFile: uploadActions.removeTempFile,
  updateSettings: settingsActions.updateSettings,
};

const defaultFormData = {
  name: '',
  captcha: '',
  title: '',
  image: '',
  status: 1,
  priority: 100,
  admin_status: 1,
  is_default: 0,
};

const applyModel = fh.createApplyModel(defaultFormData);

const onSubmit = props => redirect => async (event) => {
  const { image, isNewModel, history, formData, t } = props;
  await fh.beforeSave(event, props, redirect);
  const { model, errors } = await ModelService.update({
    ...formData,
    image: image && image.id ? image.id : '',
  });
  if (!errors) {
    if (redirect) return history.push(ModelService.baseRoute);
    if (isNewModel) return history.push(ModelService.getUpdateUrl(model.id));
    await applyModel(props.setFormData, model);
    props.updateSettings(await ModelService.getSettings());
    props.removeTempFile('image');
    fh.notify(t);
  }
  props.setErrors(!errors ? {} : errors);
  return props.setIsSubmitting(false);
};

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  defaultProps({
    getImage: ModelService.getImage,
  }),
  ...fh.defaultRecompose(defaultFormData),
  lifecycle({
    async componentDidMount() {
      await fh.initModelData(this.props, applyModel, ModelService);
      window.recaptchaOptions = {
        lang: this.props.i18n.language,
      };
    },
  }),
  withProps(props => ({
    title: props.t('Language') + fh.getTitleEnd(props),
    imageSrc: props.image && props.image.url
      ? props.image.url : ModelService.getImage(props.formData.image, 150, 150),
  })),
  withHandlers({
    onSubmit,
    onChange: fh.onChangeFormDataElement,
  }),
);

export default withRouter(hoistStatics(enhance)(WithLoading(Language, CardLoading)));



// WEBPACK FOOTER //
// ./src/views/languages/language/index.js